import lodashUtil from 'lodash'
import { gradePickerUtil } from '../../../gradePicker'

//construction of gradeDetials from the keys array sent from the rules
// since it is already done we have not changed it to the data 

export const createGreadeDeatailsFromKeys = (props) => {

  // this used in step 2 (convertingGradeDetailToGenericForm())

  let gradeDetails = {
    allGrades: false,
    gradeLevels: [],
    grades: [],
  }

  let { keys, dataTableMap, dataObj } = props
  keys.sort();
  // STEP 1

  for (let i = 0; i < keys.length; i++) {
    let cellDetials = props.dataTableMap.get(keys[i]);
    let groupPresent = false;
    if (cellDetials.group !== undefined) {
      groupPresent = true;
    }

    //gradeLevel
    if (cellDetials.gradeLevel !== undefined && cellDetials.gradeLevel !== "") {
      let isLevelNamePresent = lodashUtil.find(gradeDetails.gradeLevels, ["level", cellDetials.gradeLevel])
      if (isLevelNamePresent === undefined) {
        gradeDetails.gradeLevels.push({ "level": cellDetials.gradeLevel });
      }
    }

    // grade
    if (groupPresent) {
      let isGradePresent = lodashUtil.findIndex(gradeDetails.grades, ["grade", cellDetials.grade])
      if (isGradePresent >= 0) {
        gradeDetails.grades[isGradePresent].groups.push({ "groupCode": cellDetials.group })
      } else {
        if (cellDetials.grade !== undefined
          && cellDetials.grade !== ""
          && cellDetials.group !== "") {
          gradeDetails.grades.push({ "grade": cellDetials.grade, "groups": [{ "groupCode": cellDetials.group }] })
        }
      }
    } else {
      if (cellDetials.grade !== undefined && cellDetials.grade !== "") {
        gradeDetails.grades.push({ "grade": cellDetials.grade, "groups": [] })
      }
    }
  }
  gradeDetails = gradePickerUtil.sortingOfGrades(gradeDetails, props)
  return gradeDetails;
}

export const getSubjectsForTemplate = (props) => {
  let subject = "";
  let dataObj = props.dataTableMap.get(props.cellCode)
  if (dataObj.subject !== undefined) {
    subject = dataObj.subject.name;
  } else if (dataObj.elective !== undefined) {
    subject = dataObj.elective.name;
  }
  return subject;
}

export const getGradeForTemplate = (props) => {
  let grades = "";
  let count = 0;
  for (let i = 0; i < props.keys.length; i++) {
    let dataObj = props.dataTableMap.get(props.keys[i]);
    if (dataObj.group === undefined) {
      if (i === 0) {
        count++;
        grades = grades.concat(dataObj.grade);
      } else {
        count++;
        grades = grades.concat(", " + dataObj.grade);
      }
    } else {
      let grade = dataObj.grade + dataObj.group;
      if (i === 0) {
        count++;
        grades = grades.concat(grade);
      } else {
        count++;
        grades = grades.concat(", " + grade);
      }
    }

    if (props.keys.length > 2 && count === 2) {
      grades = grades.concat(" +" + Number(props.keys.length - 2) + " More");
      break;
    }

  }
  return grades
}

export const getToolTipString = (props) => {
  let toolTipString = ""
  for (let i = 0; i < props.keys.length; i++) {
    let dataObj = props.dataTableMap.get(props.keys[i]);
    if (dataObj.group === undefined) {
      if (i === 0) {
        toolTipString = toolTipString.concat(dataObj.grade);
      } else {
        toolTipString = toolTipString.concat(", " + dataObj.grade);
      }
    } else {
      let grade = dataObj.grade + dataObj.group;
      if (i === 0) {
        toolTipString = toolTipString.concat(grade);
      } else {
        toolTipString = toolTipString.concat(", " + grade);
      }
    }
  }
  return toolTipString;
}
/**
 * this method taken in 
 * 1. grade detail from rules ex => allgrades = false, gradeLevels = [level:elementary], grades = [{grade:1}].
 * 2. props
 * this method converts the grade detail constructed in the rules to the genric form to this application this can be used in the futur. 
 */
export const convertingGradeDetailToGenericForm = (gradeDetails, props) => {
  //STEP 2
  let master_gradeDetails = props.activeSchool.school_master.gradeLevels;

  for (let a = 0; a < master_gradeDetails.length; a++) {
    let isAllGradesPresent = true;
    let master_gradeLevelObj = master_gradeDetails[a]
    for (let b = 0; b < master_gradeLevelObj.grades.length; b++) {
      let isAllGroupsPresent = true;
      let master_gradesObj = master_gradeLevelObj.grades[b]
      let groupsLength = master_gradesObj.numberOfGroups;
      let gradeObjectInGradeDeail = lodashUtil.find(gradeDetails.grades, ["grade", master_gradesObj.gradeName])
      if (gradeObjectInGradeDeail != undefined) {
        if (gradeObjectInGradeDeail.groups.length === groupsLength) {
          gradeObjectInGradeDeail.groups = []
        } else {
          isAllGroupsPresent = false
        }
      } else {
        isAllGradesPresent = false;
        let gradeLevelIndex = lodashUtil.findIndex(gradeDetails.gradeLevels, ["level", master_gradeLevelObj.levelName])
        if (gradeLevelIndex != -1) {
          gradeDetails.gradeLevels.splice(gradeLevelIndex, 1)
        }
      }

      // after the last iteration of grades in one gradeLevel Object from master.
      if (b === master_gradeLevelObj.grades.length - 1 && isAllGradesPresent === true && isAllGroupsPresent === true) {
        for (let c = 0; c < master_gradeLevelObj.grades.length; c++) {
          let indextoRemove = lodashUtil.findIndex(gradeDetails.grades, ["grade", master_gradeLevelObj.grades[c].gradeName])
          if (indextoRemove != -1) {
            gradeDetails.grades.splice(indextoRemove, 1);
          }
        }
      }
    }
  }
  return gradeDetails
}

/**
 * this method takes the schedule_constraint Array and cellDetails selected cells object
 * cellDetails object is searched in the schedule_constraint
 * GIVES BACK the INDEX number if the object is found or else it will return undefined if no match found.
 * this is for GROUPS and GRADES It gives back only the cellDetaisl Object's INDEX.
 *  */
export const findConstraintObjIndexToReplace = (dataBase_constraintArray, cell_constraintObj) => {
  let cellObj_gradeDetails = cell_constraintObj.gradeDetails;
  let objIndex;

  //GROUPS
  if (cellObj_gradeDetails.grades[0].groups.length != 0) {
    for (let a = 0; a < dataBase_constraintArray.length; a++) {
      let scheduleConstraintObj = dataBase_constraintArray[a];
      let gradeDetails = scheduleConstraintObj.gradeDetails;
      if (gradeDetails.grades[0].groups.length != 0
        && gradeDetails.grades[0].groups[0].groupCode === cellObj_gradeDetails.grades[0].groups[0].groupCode
        && gradeDetails.grades[0].grade === cellObj_gradeDetails.grades[0].grade
        && (cell_constraintObj.subjectId != undefined ?
          scheduleConstraintObj.subjectCode === cell_constraintObj.subjectCode
          : scheduleConstraintObj.electiveId === cell_constraintObj.electiveId)) {
        objIndex = a;
        break;
      }
    }
  }
  //GRADES
  else {
    for (let b = 0; b < dataBase_constraintArray.length; b++) {
      let scheduleConstraintObj = dataBase_constraintArray[b];
      let gradeDetails = scheduleConstraintObj.gradeDetails;
      if (gradeDetails.grades[0].groups.length === 0
        && gradeDetails.grades[0].grade === cellObj_gradeDetails.grades[0].grade
        && (cell_constraintObj.subjectId != undefined ?
          scheduleConstraintObj.subjectCode === cell_constraintObj.subjectCode
          : scheduleConstraintObj.electiveId === cell_constraintObj.electiveId)) {
        objIndex = b;
        break;
      }
    }
  }

  return objIndex;
}